import React, {useState} from "react";
import {StyledReviewStore} from "./ReviewStore.style";
import Banner from "../../../../../../assets/Login/mcdBanner.png";
import mcdLogo from "../../../../../../assets/Login/mcdLogo.svg";
import Button from "components/molecules/Button";
import manageStores from "services/manageSores";
import Toast from "components/molecules/Toast";
import {useSelector} from "react-redux";
import {useAuthContext} from "Context/authContext";

const ReviewStore = ({onClose, formData, editBranch, isEditMode, onStoreCreated}) => {
    const [loading, setLoading] = useState(false);
    const business= useSelector(state => state.business.businessId);
    const { user } = useAuthContext();
    const businessIdFromAuth = user?.businessId;
    const businessId = businessIdFromAuth || business;
    const handleSubmit = async () => {
        setLoading(true);
        try {
            console.log("Full form data received:", formData);
            
            // Prepare form data for submission
            const formDataToSend = new FormData();
            
            // Store details (form1)
            const storeDetails = formData.form1;
            
            // Menu assignment (form3) - declare early to use in roundtrip_business_id logic
            const menuAssignment = formData.form3;
            
            formDataToSend.append("title", storeDetails.storeName);
            formDataToSend.append("store_email", storeDetails.storeEmail || "");
            
            // Fix address - ensure city is not empty
            const fixedAddress = {
                ...storeDetails.address,
                city: storeDetails.address.city || storeDetails.address.state || "Unknown City"
            };
            formDataToSend.append("address", JSON.stringify(fixedAddress));
            
            // Fix cuisines - send as comma-separated string (exactly as backend expects)
            const cuisineNames = storeDetails.cuisines?.map(c => c.value || c) || [];
            const cuisinesString = cuisineNames.join(',');
            formDataToSend.append("cuisines", cuisinesString);
            formDataToSend.append("restaurant", businessId);
            
            // Add roundtrip_business_id - either from store details (edit mode) or from source store (copy mode)
            const roundtripBusinessId = storeDetails.roundtrip_business_id || menuAssignment?.source_roundtrip_business_id;
            if (roundtripBusinessId) {
                formDataToSend.append("roundtrip_business_id", roundtripBusinessId);
                console.log("Adding roundtrip_business_id to payload:", roundtripBusinessId);
            }
            // Add logo and banner files (only if new files are uploaded)
            if (storeDetails.upload_image && typeof storeDetails.upload_image !== 'string') {
                formDataToSend.append("store_logo", storeDetails.upload_image);
            }
            if (storeDetails.upload_banner && typeof storeDetails.upload_banner !== 'string') {
                formDataToSend.append("store_cover_banner", storeDetails.upload_banner);
            }

            // Service types (now from form1)
            const serviceTypes = {
                delivery: storeDetails.serviceType?.some(s => s.value === "Delivery" || s === "Delivery") || false,
                pickup: storeDetails.serviceType?.some(s => s.value === "Pickup" || s === "Pickup") || false
            };
            formDataToSend.append("service_types", JSON.stringify(serviceTypes));

            // Menu assignment (form3) - already declared above
            formDataToSend.append("menu_action", menuAssignment.menu_action);
            
            // Handle source_store_id properly - extract the actual ID value
            if (menuAssignment.menu_action === 'copy' && menuAssignment.source_store_id) {
                const storeId = typeof menuAssignment.source_store_id === 'object' 
                    ? menuAssignment.source_store_id.value || menuAssignment.source_store_id._id
                    : menuAssignment.source_store_id;
                    
                console.log("Source store ID being sent:", storeId);
                formDataToSend.append("source_store_id", storeId);
            }


            // Submit to backend (create or edit)
            let response;
            if (isEditMode && editBranch?._id) {
                response = await manageStores.editStore(editBranch._id, formDataToSend);
                Toast({
                    type: "success",
                    message: response.message || "Store updated successfully!"
                });
                
                // Call refetch function to refresh stores list
                if (onStoreCreated) {
                    onStoreCreated();
                }
            } else {
                response = await manageStores.createStore(formDataToSend);
                Toast({
                    type: "success",
                    message: response.message || "Store created successfully!"
                });
                
                // Call refetch function to refresh stores list
                if (onStoreCreated) {
                    onStoreCreated();
                }
            }
            
            // Close modal
            onClose();
            
        } catch (error) {
            console.error("Error creating store:", error);
            Toast({
                type: "error",
                message: error.message || "Failed to create store"
            });
        } finally {
            setLoading(false);
        }
    };
    return (
        <StyledReviewStore>
            <h2 className="title">{isEditMode ? "Review Store Changes" : "Review Your Store"}</h2>

            {formData?.form1?.upload_banner ? (
                <img src={
                    typeof formData.form1.upload_banner === 'string' 
                        ? formData.form1.upload_banner 
                        : URL.createObjectURL(formData.form1.upload_banner)
                } alt="banner" className="banner" />
            ) : (
                <img src={Banner} alt="banner" className="banner" />
            )}
            <div className="details-wrap">
                {formData?.form1?.upload_image ? (
                    <img src={
                        typeof formData.form1.upload_image === 'string' 
                            ? formData.form1.upload_image 
                            : URL.createObjectURL(formData.form1.upload_image)
                    } alt="logo" className="logo" />
                ) : (
                    <img src={mcdLogo} alt="logo" className="logo" />
                )}
                <strong className="title">{formData?.form1?.storeName || "Store Name"}</strong>
                <span className="location-wrap">{formData?.form1?.address?.street_address || "Store Address"}</span>
                <ul className="category-wrap">
                    {formData?.form1?.serviceType?.map((service, index) => (
                        <li key={index}>{service.label || service}</li>
                    ))}
                </ul>
                <div className="cuisines-wrap">
                    <strong>Cuisines: </strong>
                    <span>{formData?.form1?.cuisines?.map(c => {
                        if (typeof c === 'string') return c;
                        return c.label || c.name || c.value || 'Unknown';
                    }).join(", ") || "No cuisines selected"}</span>
                </div>
                {!isEditMode && 
                
                <div className="menu-wrap">
                    <strong>Menu: </strong>
                    <span>{formData?.form3?.menu_action === 'copy' ? 'Copy from existing store' : 'Create new menu'}</span>
                </div>
                
                }

                <div className="btn-holder">
                    <Button variant="primary" width="343px" onClick={handleSubmit} loader={loading}>
                        {loading 
                            ? (isEditMode ? "Updating Store..." : "Creating Store...") 
                            : (isEditMode ? "Update Store" : "Finish Setup")
                        }
                    </Button>
                </div>
            </div>
        </StyledReviewStore>
    );
};

export default ReviewStore;
